import { html } from "lit";

import { customElement } from "lit/decorators.js";

import { BaseSocialButton } from "ui-components/social-login-buttons";
import { googleLogoTemplate } from "ui-components/social-logos";

@customElement("google-sign-up-button")
export class GoogleSignUpButton extends BaseSocialButton {
  override render() {
    return html`${googleLogoTemplate}`;
  }
}
